import React, { Fragment, useState } from "react";
import { FormControl } from "baseui/form-control";
import { Input, SIZE as ISIZE } from "baseui/input";
import { useStyletron } from "baseui";
import { Select, SIZE as SSIZE } from "baseui/select";
import { Textarea, SIZE as TSIZE } from "baseui/textarea";
import { Radio, RadioGroup } from "baseui/radio";
import { ACCESS_TYPES } from "../../constants/AppEnums";
import { TEMPLATE_SOLVERS_LIST } from "../../constants/TemplatesConstants";
import MultiSelect from "../../components/multi-select/MultiSelect";
import { TOPICS_LIST, INDUSTRIES_LIST } from "../../constants/TemplatesConstants";
import { useTranslation } from "react-i18next";

export default function CreateNewTemplateInfoView(props) {
  const { t } = useTranslation("template");
  const [title, setTitle] = useState(props.title);
  const [solver, setSolver] = useState(props.solver);
  const [description, setDescription] = useState(props.description);
  const [publicOrPrivate, setPublicOrPrivate] = useState(props.access);
  const [css, theme] = useStyletron();
  const [topics, setTopics] = useState(
    TOPICS_LIST.filter(
      (topic) => (props.activeTemplate?.topics || []).includes(topic.id)
    )
  );
  const [industries, setIndustries] = useState(
    INDUSTRIES_LIST.filter(
      (industry) => (props.activeTemplate?.industries || []).includes(industry.id)
    )
  );  
  
  function handleTopicsChange(topics_dict) {
    props.onTemplateTopicsChange(topics_dict.map((item) => item.id));
    setTopics(topics_dict);
  }

  function handleIndustriesChange(industries_dict) {
    props.onTemplateIndustriesChange(industries_dict.map((item) => item.id));
    setIndustries(industries_dict);
  }
  return (
    <Fragment>
      <FormControl id="project-title" label={() => t('templateTitle')}>
        <Input
          size={ISIZE.mini}
          className={css({
            width: "100%",
          })}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={(e) => props.onTemplateTitleChange(e.target.value)}
        />
      </FormControl>
      <FormControl id="new-template-solver" label={() => t('solverLabel')}>        
        <Select
          size={SSIZE.mini}
          escapeClearsValue={false}
          options={TEMPLATE_SOLVERS_LIST}
          value={solver}
          searchable={false}
          placeholder={t('solverPlaceholder')}
          onChange={(item) => {
            setSolver(item.value);
            props.onSolverChange(item.value);
          }}/>
      </FormControl>      
      <FormControl id="new-template-description" label={t('templateDescription')}>
        <Textarea
        size={TSIZE.mini}
          value={description || ""}
          onChange={(e) => setDescription(e.target.value)}
          onBlur={(e) => props.onTemplateDescriptionChange(e.target.value)}
          placeholder={t('promptTemplateDescription')}
          clearOnEscape
        />
      </FormControl>
      <FormControl id="new-template-topics" label = {() => t('topicsLabel')}>
        <MultiSelect
        size={SSIZE.mini}
          items={TOPICS_LIST}
          onChange={handleTopicsChange}
          placeholder={t('topicsPlaceholder')}
          value={topics}
        />
      </FormControl>
      <FormControl id="new-template-industries" label = {() => t('industiesLabel')}>
        <MultiSelect
        size={SSIZE.mini}
          items={INDUSTRIES_LIST}
          onChange={handleIndustriesChange}
          placeholder={t('industiesPlaceholder')}
          value={industries}
        />
      </FormControl>        
      <RadioGroup
        name="basic usage"
        onChange={(e) => {
          setPublicOrPrivate(e.target.value);
          props.onTemplateAccessChanged(e.target.value);
        }}
        value={publicOrPrivate}
      >
        <Radio
          value={ACCESS_TYPES.PUBLIC}
          description={t('templatePublicDescription')}
        >
          {t('templateAccessPublic')}
        </Radio>
        <Radio
          value={ACCESS_TYPES.PRIVATE}
          description={t('templatePrivateDescription')}
        >
          {t('templateAccessPrivate')}
        </Radio>
      </RadioGroup>
    </Fragment>
  );
}
